export default __webpack_public_path__ + "9e5153faf7c78acc2334be58cb91b5ac.png";